import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  hideBackground: PropTypes.bool,
  isRound: PropTypes.bool
};

const defaultProps = {
  hideBackground: false,
  isRound: false
};

function Facebook(props) {
  const { hideBackground, isRound, ...rest } = props;

  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...rest}>
      {!hideBackground && <rect fill="#1877F2" height="24" rx={isRound ? '100%' : 0} width="24" />}
      <path
        clipRule="evenodd"
        d="M16 6.99L14.55 6.99094C13.4129 6.99094 13.1924 7.51688 13.1924 8.28844V9.99094H15.9047L15.5513 12.6581H13.1924V19.5H10.3647V12.6581H8V9.99094H10.3647V8.025C10.3647 5.74219 11.7964 4.5 13.8866 4.5C14.888 4.5 15.7487 4.57219 16 4.605V6.99Z"
        fill="white"
        fillRule="evenodd"
      />
    </svg>
  );
}

Facebook.propTypes = propTypes;
Facebook.defaultProps = defaultProps;

export default Facebook;
